import { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  ArrowLeftStartOnRectangleIcon,
  BugAntIcon,
  Cog6ToothIcon,
  EnvelopeIcon,
  LightBulbIcon,
  SquaresPlusIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import useAuthStore from '@/store/useAuthStore'
import useGetCurrentUser from '@/services/api/auth/useGetCurrentUser'
import useLogout from '@/services/api/auth/useLogout'

export default function AccountMenu() {
  const [openBugReport, setOpenBugReport] = useState(false)
  const [openFeatureRequest, setOpenFeatureRequest] = useState(false)
  const avatar = useAuthStore((state) => state.getAvatar())
  const { data: currentUser } = useGetCurrentUser()
  const { logout } = useLogout()

  const userEmail = currentUser?.email ?? ''
  const bugFormUrl = `https://forms.clickup.com/36879818/f/135fea-8516/I45S4ZP4LVM9B7WJ2M?Email=${encodeURIComponent(userEmail)}`
  const featureRequestFormUrl = `https://forms.clickup.com/36879818/f/135fea-8596/AW8OTUG6H8RRRX49RF?Email=${encodeURIComponent(userEmail)}`

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="flex size-7 shrink-0 items-center justify-center rounded-full bg-green-default text-xs font-bold text-white"
          >
            {avatar}
          </button>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="w-[220px]" align="start">
          <DropdownMenuItem asChild>
            <Link to="/account" className="flex items-center gap-2">
              <Cog6ToothIcon className="size-4 text-txt-secondary" />
              Settings
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a
              href="https://www.profitflow.au/whats-new"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <SquaresPlusIcon className="size-4 text-txt-secondary" />
              What&apos;s New
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex items-center gap-2"
            onSelect={() => setOpenBugReport(true)}
          >
            <BugAntIcon className="size-4 text-txt-secondary" />
            Report a Bug
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex items-center gap-2"
            onSelect={() => setOpenFeatureRequest(true)}
          >
            <LightBulbIcon className="size-4 text-txt-secondary" />
            Feature Request
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a
              href="https://www.profitflow.au/home#anchors-m3racewc"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <EnvelopeIcon className="size-4 text-txt-secondary" />
              Contact Us
            </a>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="flex items-center gap-2"
            onSelect={() => logout()}
          >
            <ArrowLeftStartOnRectangleIcon className="size-4 text-txt-secondary" />
            Log Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={openBugReport} onOpenChange={setOpenBugReport}>
        <DialogContent className="flex h-[80vh] max-w-2xl flex-col">
          <DialogHeader>
            <DialogTitle>Report a Bug</DialogTitle>
            <DialogClose>
              <XMarkIcon />
            </DialogClose>
          </DialogHeader>
          <DialogBody className="flex-1 overflow-hidden p-0">
            <iframe
              key={userEmail}
              src={bugFormUrl}
              className="h-full w-full border-0"
              title="Report a Bug"
            />
          </DialogBody>
        </DialogContent>
      </Dialog>

      <Dialog open={openFeatureRequest} onOpenChange={setOpenFeatureRequest}>
        <DialogContent className="flex h-[80vh] max-w-2xl flex-col">
          <DialogHeader>
            <DialogTitle>Feature Request</DialogTitle>
            <DialogClose>
              <XMarkIcon />
            </DialogClose>
          </DialogHeader>
          <DialogBody className="flex-1 overflow-hidden p-0">
            <iframe
              key={userEmail}
              src={featureRequestFormUrl}
              className="h-full w-full border-0"
              title="Feature Request"
            />
          </DialogBody>
        </DialogContent>
      </Dialog>
    </>
  )
}
